<script lang="ts">
    import HeaderComponentModel from '@amp/web-app-components/src/components/HeaderComponentModel/HeaderComponentModel.svelte';
    import type { PageHeader } from '~/jet/models';

    // Components
    import ScopeBar from '~/components/jet/header/ScopeBar.svelte';
    import AccessoryButton from '~/components/jet/buttons/AccessoryButton/AccessoryButton.svelte';

    export let header: PageHeader;

    $: title = header?.title;
    $: hasTabs = !!header?.tabs;
</script>

<div class="header-classical">
    {#if title}
        <HeaderComponentModel textAlignment={'leading'} headerType={'A'}>
            {title}
            <svelte:fragment slot="action">
                {#if header?.sorting}
                    <AccessoryButton button={header.sorting} />
                {/if}
            </svelte:fragment>
        </HeaderComponentModel>
    {/if}
</div>
{#if hasTabs}
    <ScopeBar tabs={header.tabs} />
{/if}

<style lang="scss">
    .header-classical {
        display: contents;

        :global(.header-nav__heading) {
            font: var(--header-emphasized-serif);
        }
    }

    // Temp CSS
    .primary-button {
        background-color: var(--keyColor);
        color: #fff;
        width: 90px;
        height: 30px;
        border-radius: 6px;
        margin-inline-start: var(--bodyGutter);
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
